(function() {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodNotifications', directive);

    function directive() {
        return {
            restrict: 'E',
            scope: {},
            controller: controller,
            controllerAs: 'vm',
            bindToController: true,
            template:
                "<div class='callout callout-notification ' ng-class='vm.getNotificationClass()' ng-if='vm.notification.message'>" +
                    "<div ng-bind='vm.notification.message'></div>" +
                "</div>"
        };
    }

    controller.$inject = ['$scope', 'NotificationService', 'lodash'];

    function controller($scope, NotificationService, lodash) {
        var vm = this;

        this.$onInit = function() {
            vm.getNotificationClass = getNotificationClass;

            $scope.$watch(function() { return NotificationService.change(); }, function() {
                vm.notification = NotificationService.get();
            });
        }

        function getNotificationClass() {
            return [vm.notification.class,getNotificationTypeClass()].join(' ');
        }

        function getNotificationTypeClass() {
            if (lodash.has(vm, 'notification.type')) {
                switch (vm.notification.type) {
                    case "error":
                        return "alert";
                    case "info":
                        return "primary";
                    default:
                        return vm.notification.type;

                }
            }
            return "";
        }
    }
})();